<template>
    <popup-wrapper class="popup-code" v-if="popShow" @pop-cls="handlePopCls">
        <h3 v-html="$t('popup.code.title', { reward: rewardName })"></h3>
        <div class="code-wrapper">
            <span>{{ $t('popup.code.label') }}</span>
            <div>{{ code }}</div>
        </div>
        <div class="btn-grp">
            <a
                href="javascript:;"
                title="copy"
                class="btn-copy"
                @click.prevent="handleCopy"
                >{{ $t('popup.code.copy_btn') }}</a
            >
            <a
                href="javascript:;"
                title="exchange"
                class="btn-to-change"
                @click.prevent="handleToChange"
                >{{ $t('popup.code.redeem_btn') }}</a
            >
        </div>
    </popup-wrapper>
</template>

<script>
import popupWrapper from '@/components/popup/popup-wrapper';
import { mapActions, mapMutations } from 'vuex';
import i18n from '@/lang';
export default {
    name: 'popup-code',
    components: {
        popupWrapper
    },
    computed: {
        popShow() {
            return this.$store.state.popup.code;
        },
        codeReward() {
            return this.$store.state.codeReward;
        },
        // 兑换码
        code() {
            if (this.codeReward && this.codeReward.type_ename == 'code') {
                return this.codeReward.code;
            } else {
                return 'xxxxxxxxx';
            }
        },
        // 礼包名
        rewardName() {
            if (this.codeReward && this.codeReward.type_ename == 'code') {
                return this.codeReward.item_name;
            } else {
                return '';
            }
        }
    },
    methods: {
        ...mapMutations(['PLAY_SOUND', 'STOP_SOUND']),
        ...mapActions(['getDownloadScore']),
        handlePopCls() {
            this.$store.commit('HIDE_POPUP', 'code');
        },
        handleCopy() {
            this.PLAY_SOUND('button');
            this.$copyText(this.code).then(
                e => {
                    alert(i18n.t('popup.code.copy_success'));
                },
                e => {
                    alert('copy fail');
                }
            );
        },
        handleToChange() {
            this.PLAY_SOUND('button');
            this.getDownloadScore();
            window.open('https://app.adjust.com/a6lbweb_yedp8z2');
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 40px 40px;

    h3 {
        font-size: 28px;
        color: #9c9273;
        text-align: center;
        margin-bottom: 24px;
        line-height: 1.2;
    }
    .code-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 36px;
        margin-left: 12px;

        span {
            font-size: 20px;
            color: #474747;
            margin-right: 18px;
            text-align: center;
        }

        div {
            width: 344px;
            height: 55px;
            background: url(~@/assets/img/pop_input_bg.png) center/100% 100%
                no-repeat;
            padding-left: 20px;
            box-sizing: border-box;
            font-size: 24px;
            line-height: 55px;
            color: #9c9273;
            flex-shrink: 0;
        }
    }
    .btn-grp {
        width: 448px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 48px;
    }
    .btn-copy {
        width: 189px;
        height: 74px;
        background: url(~@/assets/img/btn_blue_square.png) center/100% 100%
            no-repeat;
        margin-right: 26px;
        line-height: 74px;
        font-size: 22px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
    .btn-to-change {
        width: 210px;
        height: 74px;
        background: url(~@/assets/img/btn_orange_square.png) center/100% 100%
            no-repeat;
        line-height: 74px;
        font-size: 22px;
        color: #fff;
        text-align: center;
        font-weight: bold;
    }
}
</style>
